import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { rSorguInputlari } from '../../../../api/models/.catalog';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';

export default ApiBaseReducer<pList, IInputDataStateModel<pList, rSorguInputlari>, rSorguInputlari>(
  ActionSubTypes.API_SORGUINPUTLARI,
  DefaultInputDataStateModel<pList, rSorguInputlari>()
);
